module.exports = __webpack_public_path__ + "img/cash-voucher.8dd3138c.png";